import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoOmics = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Icon-Architecture/16/Arch_Amazon-Omics_16" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			x1: "0%",
			y1: "100%",
			x2: "100%",
			y2: "0%",
			id: "linearGradient-1",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#055F4E",
				offset: "0%"
			}), /* @__PURE__ */ _jsx("stop", {
				stopColor: "#56C0A7",
				offset: "100%"
			})]
		}) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Icon-Architecture/16/Arch_Amazon-Omics_16",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: [/* @__PURE__ */ _jsx("g", {
				id: "Icon-Architecture-BG/16/Machine-Learning",
				fill: "url(#linearGradient-1)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle",
					x: 0,
					y: 0,
					width: 24,
					height: 24
				})
			}), /* @__PURE__ */ _jsx("g", {
				id: "Icon-Service/16/Amazon-Omics_16",
				transform: "translate(4.000000, 4.000000)",
				fill: "#FFFFFF",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M8.997,10.998 L15.997,10.998 L15.997,9.998 L8.997,9.998 L8.997,10.998 Z M8.997,4.998 L15.997,4.998 L15.997,3.998 L8.997,3.998 L8.997,4.998 Z M5.47,11.938 L5.106,12.87 C5.625,13.071 6.211,13.42 6.59,13.998 L1.344,13.998 C1.651,13.569 2.15,13.122 2.812,12.707 C3.352,12.369 3.985,12.04 4.598,11.722 C5.451,11.279 6.257,10.861 6.792,10.431 C7.57,9.805 7.951,8.982 7.976,7.998 L13.997,7.998 L13.997,6.998 L7.878,6.998 C7.565,5.996 6.597,5.204 5.788,4.695 L5.255,5.541 C6.009,6.016 6.531,6.518 6.792,6.998 L2.997,6.998 L2.997,7.998 L6.986,7.998 C6.965,8.678 6.707,9.217 6.165,9.652 C5.708,10.019 4.945,10.415 4.138,10.834 C3.507,11.162 2.854,11.5 2.28,11.86 C1.429,12.394 0,13.495 0,14.873 L0,15.998 L1,15.998 L1,14.998 L6.951,14.998 C6.96,15.063 6.976,15.122 6.98,15.19 L6.98,15.998 L7.98,15.998 L7.979,15.158 C7.883,13.674 6.991,12.531 5.47,11.938 L5.47,11.938 Z M0.003,0.644 L0.003,0 L1.003,0 L1.003,0.665 C1.003,0.684 1.006,0.813 1.044,0.998 L6.996,0.998 C7,0.95 7.001,0.915 7.001,0.909 L7.001,0 L8.001,0 L8.001,0.893 C8.003,0.933 8.049,2.418 6.431,3.61 C5.834,4.049 4.924,4.469 4.12,4.839 C3.582,5.087 3.074,5.321 2.767,5.512 C2.165,5.886 1.139,6.643 1.032,7.522 C0.924,8.43 1.131,9.028 1.749,9.584 C2.01,9.821 2.353,10.063 2.621,10.248 L2.055,11.072 C1.761,10.87 1.384,10.602 1.079,10.327 C0.223,9.556 -0.107,8.626 0.04,7.403 C0.188,6.173 1.318,5.234 2.239,4.663 C2.6,4.439 3.135,4.192 3.701,3.931 C4.462,3.581 5.323,3.184 5.837,2.805 C6.201,2.537 6.442,2.259 6.614,1.998 L1.533,1.998 C1.686,2.191 1.878,2.388 2.136,2.576 C2.322,2.711 2.522,2.848 2.732,2.982 L2.193,3.825 C1.966,3.679 1.748,3.531 1.547,3.384 C-0.044,2.225 0.001,0.708 0.003,0.644 L0.003,0.644 Z",
					id: "Fill-4"
				})
			})]
		})
	]
});
export default SvgLogoOmics;
